import React from 'react'
import { Link } from 'react-router-dom'
import studentCert from '../../../../content/images/student-cert.jpg'
import message from '../../../../components/message/message'
import redirect from '../../../../components/redirect/redirect'

function SignUpSuccess() {
    return (
        <React.Fragment>
            <div class="alert alert-info"><p>Please check your email for a verification link. You'll need to verify your email address in order to access all of the features of your trial subscription.</p>
                <p><strong>If you do not receive this email within 15 minutes, please check your spam folder.</strong></p>
            </div>
            <h1>Welcome to Great Leaps Digital!</h1>

            <div class = "row">
                <div class = "col-md-12 col-lg-7 vcenter">
                    <img class = "img-fluid" src = {studentCert} alt = "Student holding a great leaps certificate" title = "Welcome!" />
                </div><div class = "col-md-12 col-lg-5 text-left vcenter">
                    <br class = "d-block d-sm-none visible-sm" />
                    <p><strong>Congratulations</strong> again in taking this "<em>Great Leap</em>" in your student or child's reading development. If you provided your contact information, expect a member of our team to reach out to you. Great learning starts with a great first experience and it is our aim to be your solution of choice from the first step through the finish line.</p>
                    
                    <p>In the meantime if you have any questions at all do not hesitate to call, our team is always here to support you.</p>
                    
                    <p>At your service,</p>
                    
                    <p><strong>The Great Leaps Team</strong>
                    <br/><a href="mailto:glinfo@greatleaps.com">glinfo@greatleaps.com</a><br/>+1 (877) 475-3277</p>
                    
                    <p>Don't forget our <Link to = "/help/frequently-asked-questions">FAQ's</Link> and <Link href = "/dashboard">instructional videos</Link>.</p>
                    
                    <p class = "no-bottom-margin">Our mission is to <strong>equip all students</strong> for success through <strong>simple</strong> and <strong>effective</strong> educational programs.</p>
                </div>

                
            </div>

            <div class = "row">
                <div class = "offset-md-4 col-md-4">
                    <button class = "btn btn-secondary btn-lg"
                    onClick={() => {
                        redirect.send("/students", () => {
                            message.info("Add a student below then click the dolphins above to navigate to your dashboard and get started!")
                        })
                    }}>Lets Get Started!</button>
                </div>
            </div>
        </React.Fragment>
    )    
}

export default SignUpSuccess
